import { makeAmount } from "@silo/types";
import { pipe } from "effect";
import { DebtLtvAsset, DepositLtvAsset } from "@silo/utils";
import { RawDashboardMarketAsset } from "./types";

export {
  calculateLtv,
  getBorrowingPowerUsed,
  getIsAtRiskOfLiquidation,
} from "@silo/utils";

export function mapToDepositLtvAsset(
  asset: RawDashboardMarketAsset
): DepositLtvAsset {
  const {
    tokenAddress,
    decimals,
    maxLtv,
    lt,
    priceNative,
    collateralBalance,
    protectedBalance,
  } = asset;

  const balance = pipe(collateralBalance + protectedBalance, makeAmount);

  return {
    tokenAddress,
    decimals,
    maxLtv,
    lt,
    balance,
    priceNative,
  };
}

export function mapToDebtLtvAsset(
  asset: RawDashboardMarketAsset
): DebtLtvAsset {
  const { tokenAddress, decimals, priceNative, debtBalance } = asset;

  return { tokenAddress, decimals, priceNative, balance: debtBalance };
}
